
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 20v3h12v-2.583C13 19.036 14.119 18 15.5 18H3a2 2 0 00-2 2v0z","stroke":"#000","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M15.5 18c1.294 0 2.5.924 2.5 2.5a2.5 2.5 0 005 0V1H7v17","stroke":"#000","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M12 12h6m-6-5h6-6z","stroke":"#000","stroke-miterlimit":"10","stroke-linecap":"square"}})])
      }
    
      }
    